import { useCVStore } from '../stores/cv.store';

export interface StoredCV {
	id: string;
	user_id: string;
	filename: string;
	content: string; // This is the public URL
	file_size: number;
	file_type: string;
	created_at: string;
	updated_at: string;
}

export const useCV = () => {
  const { cvs, loading, cvError, fetchCVs } = useCVStore();
//   console.log("CVS are : ",cvs)
//   const { user, loading: authLoading } = useAuthStore();

//   useEffect(() => {s
//     // Initial fetch when the component mounts and user is available
//     if (user && !authLoading) {
//       fetchCVs();
//     }
//   }, []);

	return {
		cvs,
		loading: loading,
		refetch: fetchCVs,
		cvError,
	};
};